import { Ref, useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import TagsButton from "./Buttons/TagsButton";
import { useDataLayerContext, useDataLayerPopulator } from "./ContextLayer/DataProvider/DataProvider";
import { useWordUpdaterMutation } from "../hooks/engineHooks";
import { useSettingsStorageContext } from "./ContextLayer/SettingsStorageProvider";
import { FOREIGN_LANGUAGE, NATIVE_LANGUAGE } from "./Dictionary";
import { DateTime } from "luxon";
import { useMediaQuery } from "@mui/material";
import gsap from "gsap";
import MorphSVGPlugin from "gsap/MorphSVGPlugin";
import { DictionaryEntryType } from "./ContextLayer/DataProvider/types";
import { useDictinaryFilter } from "./ContextLayer/DataProvider/CommonDataMethods";

const BottomBarAtom = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 10px;

  margin: 0 auto;
  height: 120px;

  & #Bottom {
    box-shadow: 0 8px 20px red;
  }

  & #TopPlateC, & #Top {
    cursor: pointer;
  }

  & #GreenHalo, & #YellowHalo {
    opacity: 0.8;
    transition: opacity var(--transition-duration-slow);
  }

  & #CattivaRisposta #No, & #OK, & #Progress {
    pointer-events: none;
  }

  // & #Top path, & #p0b, & #p0m {
  //   filter: blur(2px);
  //   transition: filter var(--transition-duration-slow);
  // }

  // & #Top path.heated {
  //   filter: blur(1px);
  // }

  // & #p0b.heat0 {
  //   filter: blur(0px);
  // }

  // & #p0b.heat1 {
  //   filter: blur(1.8px);
  // }

  // & #p0b.heat2 {
  //   filter: blur(3.5px);
  // }

  // & #p0b.heat3 {
  //   filter: blur(5px);
  // }



  // & #p0m.heat0 {
  //   filter: blur(0px);
  // }

  // & #p0m.heat1 {
  //   filter: blur(1px);
  // }

  // & #p0m.heat2 {
  //   filter: blur(2px);
  // }

  // & #p0m.heat3 {
  //   filter: blur(4px);
  // }
`

// const CattivaRispostaAtom = styled.div`
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   height: 50px;
//   aspect-ratio: 1;
//   margin-bottom: 15px;
//   color: white;
//   background-color: #02a4f6;
//   border-radius: 100%;
//   box-sizing: border-box;
//   font-family: "FixelVariable", sans-serif;
//   font-weight: 700;
//   font-size: 0.8rem;
//   cursor: pointer;
// `

type BottomSectionProps = {
  children?: React.ReactNode | React.ReactNode[],
  ref?: Ref<HTMLDivElement>
  tagsButtonAction: () => void
};

export default function BottomSection({ ref, children, tagsButtonAction }: BottomSectionProps) {
  const { dataLayer, setDataLayer } = useDataLayerContext();
  const updateWordMutation = useWordUpdaterMutation();
  const { settings } = useSettingsStorageContext();
  const populateDataLayer = useDataLayerPopulator();
  const isWideScreen = useMediaQuery('screen and (orientation: landscape) and (min-width: 1200px)');

  const [heat, setHeat] = useState<number>(0);

  gsap.registerPlugin && gsap.registerPlugin(MorphSVGPlugin);

  const buonaRisposta = () => {
    setHeat(heat < 3 ? heat + 1 : heat);
    // return;
    if (!dataLayer.ready || dataLayer.currentIteration?.currentDictionaryEntry === null) return;

    const updatedDictionary = dataLayer.dictionary.map(dictionaryEntry => {
      if (settings.deviceID === null || settings.deviceID === undefined) return dictionaryEntry;

      if (dictionaryEntry.id === dataLayer.currentIteration?.currentDictionaryEntry?.id) {
        return {
          ...dictionaryEntry,
          statistics: {
            device_id: settings.deviceID,
            mode: settings.currentLanguage === 'native' ? NATIVE_LANGUAGE : FOREIGN_LANGUAGE,
            strength: dictionaryEntry.statistics.device_id === undefined ? 1 : dictionaryEntry.statistics.strength < 5 ? dictionaryEntry.statistics.strength + 1 : dictionaryEntry.statistics.strength,
            lastview: DateTime.now().toISO(),
            view_count: dictionaryEntry.statistics.view_count + 1
          }
        }
      }
      return dictionaryEntry;
    })

    const aggregationData = populateDataLayer(updatedDictionary);

    setDataLayer({
      ...dataLayer,
      dictionary: updatedDictionary,
      currentIteration: aggregationData.currentIteration,
    });

    updateWordMutation.mutateAsync({
      wordId: dataLayer.currentIteration?.currentDictionaryEntry?.id,
      correct: 1,
      deviceID: settings.deviceID,
      currentLanguage: settings.currentLanguage,
      // tags: dataLayer?.tags || []
    })/*.then(async (data) => {
            // const data: DictionaryType = await response.json();
            if(!data?.ready) return;

            const aggregationData = populateDataLayer(data.dictionary);
            setDataLayer({
              ...aggregationData,
              tags: dataLayer.tags
            });
          }) */.finally(() => {
      // if (typeof props.onComplete === 'function') props.onComplete();
    });
  }

  const cattivaRisposta = () => {
    if (!dataLayer.ready || dataLayer.currentIteration?.currentDictionaryEntry === null) return;

    setHeat(0);
    // return;

    // if (typeof props.onClick === 'function') props.onClick();

    const updatedDictionary = dataLayer.dictionary.map(dictionaryEntry => {
      if (settings.deviceID === null || settings.deviceID === undefined) return dictionaryEntry;

      if (dictionaryEntry.id === dataLayer.currentIteration?.currentDictionaryEntry?.id) {
        return {
          ...dictionaryEntry,
          statistics: {
            device_id: settings.deviceID,
            strength: 0,
            mode: settings.currentLanguage === 'native' ? NATIVE_LANGUAGE : FOREIGN_LANGUAGE,
            lastview: DateTime.now().toISO(),
            view_count: dictionaryEntry.statistics.device_id === undefined ? 1 : dictionaryEntry.statistics.view_count + 1
          }
        }
      }
      return dictionaryEntry;
    })

    const aggregationData = populateDataLayer(updatedDictionary);

    setDataLayer({
      ...dataLayer,
      dictionary: updatedDictionary,
      currentIteration: aggregationData.currentIteration,
    });

    // if (typeof props.onComplete === 'function') props.onComplete();

    updateWordMutation.mutateAsync({
      wordId: dataLayer.currentIteration?.currentDictionaryEntry?.id,
      correct: 0,
      deviceID: settings.deviceID,
      currentLanguage: settings.currentLanguage,
    }).finally(() => {
      // if (typeof props.onComplete === 'function') props.onComplete();
    });
  }

  useEffect(() => {
    const keyboardHandler = (e: KeyboardEvent) => {
      if (document.getElementById('quickEntry')?.classList.contains('open')) return;

      switch (e.key) {
        case ' ':
          buonaRisposta();
          break;
        case 'Control':
          cattivaRisposta();
          break;
      }
    }

    document.addEventListener('keydown', keyboardHandler);

    return () => {
      document.removeEventListener('keydown', keyboardHandler);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataLayer]);

  const breakpointrsB = useMemo(() => [
    [
      "M71,122.062C87.557,122.062 101,136.443 101,153C101,169.557 87.557,183 71,183C54.443,183 41,169.557 41,153C41,136.443 54.443,122.062 71,122.062Z", // 0%
      "M71,122.062C87.557,122.062 101,136.443 101,153C101,169.557 87.557,183 71,183C54.443,183 41,169.557 41,153C41,136.443 54.443,122.062 71,122.062Z"  // 0% Wiggle
    ], [
      "M71,113.294C87.557,113.294 101,136.443 101,153C101,169.557 87.557,183 71,183C54.443,183 41,169.557 41,153C41,136.443 54.443,113.294 71,113.294Z", // 25%
      "M71,108.882C87.557,108.882 101,136.443 101,153C101,169.557 87.557,183 71,183C54.443,183 41,169.557 41,153C41,136.443 54.443,108.882 71,108.882Z"  // 25% Wiggle
    ], [
      "M71,101.463C87.557,101.463 101,136.443 101,153C101,169.557 87.557,183 71,183C54.443,183 41,169.557 41,153C41,136.443 54.443,101.463 71,101.463Z", // 50%
      "M71,95.548C87.557,95.548 101,136.443 101,153C101,169.557 87.557,183 71,183C54.443,183 41,169.557 41,153C41,136.443 54.443,95.548 71,95.548Z"  // 50% Wiggle
    ], [
      "M71,77.801C87.557,77.801 101,136.443 101,153C101,169.557 87.557,183 71,183C54.443,183 41,169.557 41,153C41,136.443 54.443,77.801 71,77.801Z", // 75%
      "M71,71.041C87.557,71.041 101,136.443 101,153C101,169.557 87.557,183 71,183C54.443,183 41,169.557 41,153C41,136.443 54.443,71.041 71,71.041Z"  // 75% Wiggle
    ]
  ], []);

  const breakpointrsM = useMemo(() => [
    [
      "M71,122.032C87.557,122.032 101,136.443 101,153C101,169.557 87.557,183 71,183C54.443,183 41,169.557 41,153C41,136.443 54.443,122.032 71,122.032Z", // 0%
      "M71,122.032C87.557,122.032 101,136.443 101,153C101,169.557 87.557,183 71,183C54.443,183 41,169.557 41,153C41,136.443 54.443,122.032 71,122.032Z"  // 0% Wiggle
    ], [
      "M71,118.385C87.557,118.385 101,136.443 101,153C101,169.557 87.557,183 71,183C54.443,183 41,169.557 41,153C41,136.443 54.443,118.385 71,118.385Z", // 25%
      "M71,116.538C87.557,116.538 101,136.443 101,153C101,169.557 87.557,183 71,183C54.443,183 41,169.557 41,153C41,136.443 54.443,116.538 71,116.538Z"  // 25% Wiggle
    ], [
      "M71,112.208C87.557,112.208 101,136.443 101,153C101,169.557 87.557,183 71,183C54.443,183 41,169.557 41,153C41,136.443 54.443,112.208 71,112.208Z", // 50%
      "M71,109.561C87.557,109.561 101,136.443 101,153C101,169.557 87.557,183 71,183C54.443,183 41,169.557 41,153C41,136.443 54.443,109.561 71,109.561Z"  // 50% Wiggle
    ], [
      "M71,101.62C87.557,101.62 101,136.443 101,153C101,169.557 87.557,183 71,183C54.443,183 41,169.557 41,153C41,136.443 54.443,101.62 71,101.62Z", // 75%
      "M71,96.326C87.557,96.326 101,136.443 101,153C101,169.557 87.557,183 71,183C54.443,183 41,169.557 41,153C41,136.443 54.443,96.326 71,96.326Z"  // 75% Wiggle
    ]
  ], []);

  useEffect(() => {
    // const Top = document.querySelector('#Top path');
    const GreenHalo = document.getElementById('GreenHalo');
    const YellowHalo = document.getElementById('YellowHalo');
    if (GreenHalo !== null && YellowHalo !== null) {
      GreenHalo.style.opacity = "" + (0.3 + heat / 10);
      YellowHalo.style.opacity = "" + (0.3 + heat / 10);
    }

    // const p0b = document.getElementById('p0b');
    // if (p0b !== null) {
    //   p0b.classList.remove('heat0');
    //   p0b.classList.remove('heat1');
    //   p0b.classList.remove('heat2');
    //   p0b.classList.remove('heat3');
    //   p0b.classList.add('heat' + heat);
    // }

    // const p0m = document.getElementById('p0m');
    // if (p0m !== null) {
    //   p0m.classList.remove('heat0');
    //   p0m.classList.remove('heat1');
    //   p0m.classList.remove('heat2');
    //   p0m.classList.remove('heat3');
    //   p0m.classList.add('heat' + heat);
    // }

    const mtimeline = gsap.timeline({
      id: "Middle layer timeline",
    });
    const btimeline = gsap.timeline({
      id: "Bottom layer timeline",
    });

    // run only in browser
    if (typeof window === "undefined") return;

    (async () => {
      try {
        mtimeline.to("#Middle path", {
          duration: 0.2,
          ease: "power1.in",
          morphSVG: {
            shape: breakpointrsM[heat][0]
          }
        });

        mtimeline.to("#Middle path", {
          duration: 0.2,
          ease: "power1.inOut",
          repeat: -1,
          yoyo: true,
          morphSVG: {
            shape: breakpointrsM[heat][1]
          }
        });

        // GSDevTools.create({animation: mtimeline});



        btimeline.to("#Bottom path", {
          duration: 0.15,
          ease: "power1.in",
          morphSVG: {
            shape: breakpointrsB[heat][0]
          }
        });

        btimeline.to("#Bottom path", {
          duration: 0.2,
          ease: "power1.inOut",
          yoyo: true,
          repeat: -1,
          morphSVG: {
            shape: breakpointrsB[heat][1]
          }
        });
        // GSDevTools.create({animation: btimeline});
      } catch (err) {
        // fail silently if GSAP/MorphSVGPlugin isn't available
        console.warn("GSAP morph failed", err);
      }
    })();

    return () => {
      if (mtimeline && typeof mtimeline.kill === "function") mtimeline.kill();
      if (btimeline && typeof btimeline.kill === "function") btimeline.kill();
    };
  }, [heat, breakpointrsB, breakpointrsM])


  const filterDictonary = useDictinaryFilter();
  const filteredDictionary = filterDictonary(dataLayer.dictionary)

  const score = useMemo(() => {
    let score = 0;

    if (filteredDictionary.length * 5 === 0) return 0;

    filteredDictionary.forEach((entry: DictionaryEntryType) => {
      score += entry.statistics?.strength || 0;
    });

    // console.log(`%cscore recalculated - ${score} / ${filteredDictionary.length * 5}`, "color: #ffa958ff");

    return 144 * score / (filteredDictionary.length * 5);
  }, [filteredDictionary]);

  return (
    <BottomBarAtom ref={ref}>
      {/* <CattivaRispostaAtom onClick={cattivaRisposta}>NO</CattivaRispostaAtom> */}

      <svg width="375" height="214" viewBox="60 58 250 143" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" xmlSpace="preserve" style={{ fillRule: "evenodd", clipRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 1.5 }}>
        <g id="_0-" transform="matrix(3.763441,0,0,1.290323,-60.215054,-49.032258)">
          <rect x="16" y="38" width="93" height="155" style={{ fill: "rgb(210,192,93)", fillOpacity: 0 }} />
          <clipPath id="_clip1">
            <rect x="16" y="38" width="93" height="155" />
          </clipPath>
          <g clipPath="url(#_clip1)">
            <g id="Halos">
              <g id="YellowHalo" transform="matrix(0.305463,-0.232936,0.067212,0.749797,-37.714498,81.899176)">
                <g style={{ filter: "url(#_Effect2)" }}>
                  <circle cx="300.5" cy="194.5" r="42.5" style={{ fill: "rgb(226,192,93)" }} />
                </g>
              </g>
              <g id="GreenHalo" transform="matrix(0.314589,-0.231688,0.04046,0.467344,324.322335,-134.520025)">
                <g style={{ filter: "url(#_Effect3)" }}>
                  <ellipse cx="-875" cy="204" rx="41" ry="40" style={{ fill: "rgb(52,255,246)", fillOpacity: 0.35 }} />
                </g>
              </g>
            </g>
            <g id="CattivaRisposta" transform="matrix(0.265714,0,0,0.775,330.722576,-307.417328)">
              <g id="Shadow" transform="matrix(2.106895,-0.645065,0.390339,1.274917,889.852024,-848.401103)">
                <path d="M-1032.688,613.142C-1030.149,613.537 -1032.106,621.065 -1032.098,623.173C-1032.091,624.975 -1030.741,632.26 -1032.465,632.708C-1037.375,633.983 -1054.305,628.748 -1054.305,622.953C-1054.305,617.158 -1038.465,612.244 -1032.688,613.142Z" fill="rgb(17,56,49)" fillOpacity={0.08} />
              </g>
              <g id="ReflectedLight" transform="matrix(1.052977,-0.282405,0.309691,1.154717,-138.400091,-401.186295)">
                <g filter="url(#_Effect6)">
                  <circle cx="-1038.5" cy="622.5" r="10.5" fill="rgb(194,241,204)" fillOpacity={0.69} />
                </g>
              </g>
              <g id="Highlight" transform="matrix(1.238095,0,0,1.238095,243.261905,-158.714286)">
                <circle cx="-1038.5" cy="622.5" r="10.5" fill="rgb(145,218,206)" />
              </g>
              <g id="TopPlateC" transform="matrix(1.238095,0,0,1.238095,242.261905,-158.714286)">
                <circle onClick={cattivaRisposta} cx="-1038.5" cy="622.5" r="10.5" fill="rgb(93,201,183)" />
              </g>
              <g id="No" transform="matrix(0.433735,-0,0,-0.433735,-1047.421147,618.051712)">
                <path d="M20.182,9.364L14.445,9.364L15.309,5.209L15.336,4.918C15.336,4.545 15.182,4.2 14.936,3.955L13.973,3L7.991,8.991C7.655,9.318 7.455,9.773 7.455,10.273L7.455,19.364C7.455,20.364 8.273,21.182 9.273,21.182L17.454,21.182C18.209,21.182 18.854,20.727 19.127,20.073L21.873,13.664C21.954,13.454 22,13.236 22,13L22,11.182C22,10.182 21.182,9.364 20.182,9.364ZM4.886,10.273L1.25,10.273L1.25,21.182L4.886,21.182L4.886,10.273Z"
                  fill="none" stroke="rgb(187,248,255)" strokeWidth={2.08} strokeLinecap="butt" strokeMiterlimit={2} />
              </g>
            </g>
            <g id="BuonaRisposta" transform="matrix(1,0,0,1,-3.188571,0)">
              <g id="Bottom" transform="matrix(0.283429,0,0,0.826667,51.668932,31.2575)">
                <path id="p0b" filter="url(#MediumBlur)" d="M71,122.062C87.557,122.062 101,136.443 101,153C101,169.557 87.557,183 71,183C54.443,183 41,169.557 41,153C41,136.443 54.443,122.062 71,122.062Z" style={{ fill: "url(#BottomRadialGradient)" }} />
              </g>
              <g id="Middle" transform="matrix(0.274571,0,0,0.800833,52.297789,35.21)">
                <path id="p0m" filter="url(#MediumBlur)" d="M71,122.032C87.557,122.032 101,136.443 101,153C101,169.557 87.557,183 71,183C54.443,183 41,169.557 41,153C41,136.443 54.443,122.032 71,122.032Z" style={{ fill: "url(#MiddleRadialGradient)" }} />
              </g>
              <g id="Top" transform="matrix(0.265714,0,0,0.775,52.926647,39.1625)">
                <path filter="url(#SmallBlur)" onClick={buonaRisposta} d="M71,122C87.557,122 101,136.443 101,153C101,169.557 87.557,183 71,183C54.443,183 41,169.557 41,153C41,136.443 54.443,122 71,122Z" style={{ fill: "url(#TopRadialGradient)" }} />
              </g>
              <g transform="matrix(0.265714,0,0,0.775,1.651429,28.7)">
                <path id="Progress" strokeDasharray={"144,144"} strokeDashoffset={144 - score} d="M264,138.9C278.902,138.9 291,151.098 291,166C291,180.902 278.902,193 264,193C249.098,193 237,180.902 237,166C237,151.098 249.098,138.9 264,138.9" style={{ fill: "none", stroke: "rgb(255,157,47)", strokeWidth: 2 }} />
              </g>
              <g id="OK" transform="matrix(0.25611,0,0,0.746988,68.955577,146.862173)">
                <path d="M20.182,9.364C21.182,9.364 22,10.182 22,11.182L22,13C22,13.236 21.954,13.455 21.873,13.664L19.127,20.073C18.855,20.727 18.209,21.182 17.455,21.182L9.273,21.182C8.273,21.182 7.455,20.364 7.455,19.364L7.455,10.273C7.455,9.773 7.655,9.318 7.991,8.991L13.973,3L14.936,3.955C15.182,4.2 15.336,4.545 15.336,4.918L15.309,5.209L14.446,9.364L20.182,9.364ZM4.886,10.273L4.886,21.182L1.25,21.182L1.25,10.273L4.886,10.273Z" style={{ fill: "none", stroke: "rgb(255,143,44)", strokeWidth: 1.76, strokeLinecap: "butt", strokeMiterlimit: 2 }} />
              </g>
            </g>

          </g>
        </g>
        <defs>
          <filter id="SmallBlur">
            <feGaussianBlur stdDeviation="1" />
          </filter>
          <filter id="MediumBlur">
            <feGaussianBlur stdDeviation="3" />
          </filter>
          <filter id="_Effect2" filterUnits="userSpaceOnUse" x="172.2" y="50.049" width="256.6" height="288.901">
            <feGaussianBlur in="SourceGraphic" stdDeviation="15.473" />
          </filter>
          <filter id="_Effect3" filterUnits="userSpaceOnUse" x="-948.328" y="100.53" width="146.655" height="206.94">
            <feGaussianBlur in="SourceGraphic" stdDeviation="15" />
          </filter>
          <radialGradient id="BottomRadialGradient" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(0,-33,33,0,71,137)">
            <stop offset="0" stopColor="rgb(255,222,133)" stopOpacity={1} />
            <stop offset="1" stopColor="rgb(255,110,88)" stopOpacity={1} />
          </radialGradient>
          <radialGradient id="MiddleRadialGradient" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(0,-31,31,0,71,142)">
            <stop offset="0" stopColor="rgb(255,251,224)" stopOpacity={1} />
            <stop offset="1" stopColor="rgb(246,197,118)" stopOpacity={1} />
          </radialGradient>
          <radialGradient id="TopRadialGradient" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(32,39,-39,32,56,134)">
            <stop offset="0" stopColor="rgb(255,255,233)" stopOpacity={1} />
            <stop offset="1" stopColor="rgb(255,205,159)" stopOpacity={1} />
          </radialGradient>
          <filter id="_Effect5" filterUnits="userSpaceOnUse" x="-957.8" y="100.53" width="165.6" height="206.94">
            <feGaussianBlur in="SourceGraphic" stdDeviation="8.228" />
          </filter>
          <filter id="_Effect6" filterUnits="userSpaceOnUse" x="-1059.589" y="602.344" width="42.177" height="40.311">
            <feGaussianBlur in="SourceGraphic" stdDeviation="1.682" />
          </filter>
        </defs>
      </svg>



      {!isWideScreen ? <TagsButton onClick={tagsButtonAction} /> : null}
    </BottomBarAtom>
  );
}